// modal/detail/ui/RowItem.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { PillIcon } from './PillIcon';

export function RowItem({ icon, tone = 'teal', title, subtitle, right }) {
  const theme = useMuiTheme();

  return (
    <MDBox
      sx={{
        p: 1.25,
        borderRadius: '16px',
        border: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        gap: 1.2,
      }}
    >
      <PillIcon icon={icon} tone={tone} />
      <MDBox sx={{ minWidth: 0 }}>
        <MDTypography variant="button" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
          {title}
        </MDTypography>
        {subtitle ? (
          <MDTypography variant="caption" sx={{ color: theme.palette.text.secondary }}>
            {subtitle}
          </MDTypography>
        ) : null}
      </MDBox>

      <MDBox sx={{ ml: 'auto' }}>{right}</MDBox>
    </MDBox>
  );
}
